import { useTranslation } from 'react-i18next';

import { Classroom, isJourneyClassroom } from '@innovamat/ga-features';

import { useOrganization } from '../../../../../hooks/use-organization';
import { isClassroomTeacherEnrolledManually } from '../../../../../modules/enrollment/teacher-enrollment';
import {
  isTeacherCreatedManually,
  type ClassroomTeacher,
} from '../../../../../modules/teacher/teacher';

type UseClassroomTeachersColumnsVisibilityReturn = {
  showEnrollmentStatusColumn: boolean;
  showIcon: (teacher: ClassroomTeacher) => boolean;
  getIconTooltip: (teacher: ClassroomTeacher) => string;
};

type UseClassroomTeachersColumnsVisibilityVariables = {
  teachers: ClassroomTeacher[];
  classroom?: Classroom;
};

function useClassroomTeachersColumnsVisibility({
  classroom,
  teachers,
}: UseClassroomTeachersColumnsVisibilityVariables): UseClassroomTeachersColumnsVisibilityReturn {
  const { isRosteringEnabled } = useOrganization();
  const { t } = useTranslation();
  const hasManuallyEnrolledTeachers = teachers.some((teacher) =>
    isClassroomTeacherEnrolledManually(teacher)
  );

  return {
    showEnrollmentStatusColumn:
      isRosteringEnabled && hasManuallyEnrolledTeachers && !isJourneyClassroom(classroom),
    showIcon: (teacher: ClassroomTeacher) =>
      !teacher.isInvitation &&
      !teacher.isSchoolInvitation &&
      isClassroomTeacherEnrolledManually(teacher),
    getIconTooltip: (teacher: ClassroomTeacher) =>
      isTeacherCreatedManually(teacher)
        ? t('teachers.created-manually.warning')
        : t('teachers.assigned-manually.warning'),
  };
}

export { useClassroomTeachersColumnsVisibility };
